/* eslint-disable no-undef */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
// @ts-nocheck

import LoadingSpinner from "components/LoadingSpinner";
import PopupMessage from "components/popup-message";
import PopupOtp from "components/popup-otp";
import PopupReceiveGifts from "components/popup-receive-gifts";
import PopupWhishSuccess from "components/popup-succes-wish";
import PopupSuccessNote from "components/popup-success-note";
import PopupWhishNote from "components/popup-wish-note";
import AppConfigs from "configs/env";
import { END_DATE, LISTSONG, START_DATE } from "constants/common";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import actions from "redux/home/actions";
import { checkPhoneNetwork } from "utils";
import InformationPageView from "./view";
import { requestButtonTracking } from "help/Tracking";

const InformationPage = (props) => {
  const myRef = useRef(null);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    getValues,
    reset,
  } = useForm();
  const dispatch = useDispatch();

  const [imageUrl, setImageUrl] = useState("");
  const [modal, setModal] = useState(false);
  const [modalOtp, setModalOtp] = useState(false);
  const [content, setContent] = useState("");
  const [otp, setOtp] = useState("");
  const [isErrorOTP, setIsErrorOTP] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [code, setCode] = useState("");
  const [birthDay, setBirthDay] = useState();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [fullName, setFullName] = useState("");
  const [address, setAddress] = useState("");
  const [OtpRequestTime, setOtpRequestTime] = useState("");
  const [OtpResponseTime, setOtpResponseTime] = useState("");
  const [nameBtn, setNameBtn] = useState("");
  const [nameBtn1, setNameBtn1] = useState("");
  const [groupBtnBlock, setGroupBtnBlock] = useState(false);
  const [nameBtn2, setNameBtn2] = useState("");
  const [timerId, setTimerId] = useState(null);
  const [dataModalTopup, setDataModalTopup] = useState({});
  const [isErrorPhoneNumber, setIsErrorPhoneNumber] = useState(false);
  const [networkPhone, setNetworkPhone] = useState("");
  const [genderSelected, setGenderSelected] = useState(null);
  const [store, setStore] = useState({});
  const [rewardData, setRewardData] = useState({});
  const [valueDate, onChangeDate] = useState();
  const [birthError, setBirthError] = useState(false);
  const [isDisableInput, setIsDisableInput] = useState(false);

  const [isShowModalWhishNote, setIsShowModalWhishNote] = useState(false);
  const [isShowModalSuccessNote, setIsShowModalSuccessNote] = useState(false);
  const [isShowModalSuccessWish, setIsShowModalSuccessWish] = useState(false);
  const { state } = useLocation();
  const [wishContent, setWishContent] = useState("");
  const [songName, setSongName] = useState("");
  const songLinkRef = useRef("");
  const [isShowModalReceiveGifts, setIsShowModalReceiveGifts] = useState(false);
  const [statusSong, setStatusSong] = useState("paused");
  const audioRef = useRef(null);
  const audioCurrentTimeRef = useRef(0);
  const dataSubmitRef = useRef({});
  const codeRef = useRef("");
  const timestampRef = useRef("");
  const actionTypeRef = useRef("");
  const [frameName, setFrameName] = useState("");
  const getCampaignInfo = () => {
    setIsLoading(true);
    dispatch(
      actions.GET_CAMPAIGN_INFO.request(
        {},
        (res) => {
          setIsLoading(false);
        },
        (err) => {
          setIsLoading(false);
          checkError(err?.data?.error?.code);
        }
      )
    );
  };
  useEffect(() => {
    reset();
    getCampaignInfo();
  }, []);

  useEffect(() => {
    const data = state?.wishData;
    let code = data?.code;
    let stateTemp = data;
    if (state?.isShowPopup) {
      setIsShowModalReceiveGifts(true);
    }
    if (!code) {
      let wish = localStorage.getItem("wish");
      wish = JSON.parse(wish);
      code = wish?.code;
      stateTemp = wish;
    }
    if (code) {
      if (!stateTemp?.greetingMessage) {
        navigate("/");
        return;
      }
      codeRef.current = stateTemp.code;
      const currentSongId = LISTSONG.find(
        (elm) => elm.link === stateTemp?.greetingSongLink
      )?.id;
      setSongName(`Bài Hát ${currentSongId}`);
      songLinkRef.current = stateTemp?.greetingSongLink;
      setWishContent(stateTemp?.greetingMessage);
      setFrameName(stateTemp?.greetingFrame);

      const phoneNumber = localStorage.getItem("phsjha");
      const userName = localStorage.getItem("uoioioas");
      if (phoneNumber) {
        setValue("phone", phoneNumber);
      }

      if (userName) {
        setValue("fullName", userName);
      }
    } else {
      const codeTemp = localStorage.getItem("cghjfkhgj");
      if (codeTemp) {
        navigate("/");
      } else {
        navigate("/guide");
      }
    }
  }, [state]);

  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      console.log("value, { name, type }", value, name, type);
      let isErr = false;
      if (name === "phone") {
        if (value.phone.length >= 3) {
          let networkPhoneTmp = checkPhoneNetwork(
            value.phone,
            isErrorPhoneNumber
          );
          setNetworkPhone(networkPhoneTmp);
          if (networkPhoneTmp === "") {
            isErr = true;
            setIsErrorPhoneNumber(true);
          }
        } else {
          setIsErrorPhoneNumber(false);
        }
      }

      if (
        value.fullName.trim() !== "" &&
        value.phone !== "" &&
        value.phone.length === 10 &&
        value.isAgree &&
        !isErrorPhoneNumber
      ) {
        removeDisableBtn("#btn-register");
      } else {
        addDisableBtn("#btn-register");
      }
    });
    return () => subscription.unsubscribe();
  }, [watch, isErrorPhoneNumber, store, birthError]);

  const hideModal = () => {
    setModal(false);
    setContent("");
    setNameBtn("");
    setNameBtn1("");
    setNameBtn2("");
    document.body.classList.remove("modal-open");
  };
  const showModalWhish = () => {
    setIsShowModalWhishNote(true);
    setDataModalTopup(wishContent);
  };
  const startTimer = () => {
    if (timerId) clearTimeout(timerId);
    setTimerId(setTimeout(hideModal, 10000));
  };

  const stopTimer = () => clearTimeout(timerId);

  const removeModalOpen = () => {
    setIsLoading(false);
    document.body.classList.remove("modal-open");
  };

  useEffect(() => {
    document.body.classList.add("bgr-blue");
    document.body.classList.remove("bgr-game");
    let startDate = moment(START_DATE, "DD/MM/YYYY"); //20/03/2023
    let endDate = moment(END_DATE, "DD/MM/YYYY"); //20/05/2023
    let today = moment();

    setIsDisableInput(false);
    // if (today < startDate) {
    //   checkError("NotStartYetError");
    //   // setIsDisableInput(true);
    // } else if (today > endDate) {
    //   checkError("CampaignIsOver");
    //   // setIsDisableInput(true);
    // }
    return stopTimer;
  }, []);

  const showModal = () => {
    setModalOtp(false);
    setModal(true);
    document.body.classList.add("modal-open");
  };
  const closeModalOTP = () => {
    setIsErrorOTP(false);
    setOtp("");
    setModalOtp(false);
    document.body.classList.remove("modal-open");
    removeDisableBtn("#btn-register");
  };
  const onSubmit = (data) => {
    if (data.fullName !== "" && data.phone !== "" && data.isAgree) {
      dataSubmitRef.current = {
        phoneNumber: data.phone,
        code: codeRef.current,
        name: data.fullName,
      };
      requestOTP(dataSubmitRef.current);
    }
  };

  const addDisableBtn = (id) => {
    const el = document.querySelector(id);
    el.classList.add("disabled");
  };

  const removeDisableBtn = (id) => {
    const el = document.querySelector(id);
    el.classList.remove("disabled");
  };

  const handleSubmitOTP = () => {
    verifyOTP();
  };

  const resendOTP = () => {
    setIsErrorOTP(false);
    setOtp("");
    requestOTP(dataSubmitRef.current);
  };

  const verifyOTP = () => {
    dispatch(
      actions.VERIFY_OTP.request(
        {
          phoneNumber: dataSubmitRef.current.phoneNumber,
          otp: otp,
          otpTimestamp: timestampRef.current,
          userName: dataSubmitRef.current.name,
        },
        (res) => {
          localStorage.setItem("sjkhjk", res?.signature);
          localStorage.setItem("tjfsaj", res?.timestamp);
          localStorage.setItem("uoioioas", dataSubmitRef.current.name);
          localStorage.setItem("phsjha", dataSubmitRef.current.phoneNumber);
          localStorage.setItem("cghjfkhgj", codeRef.current);
          try {
            audioRef.current.pause();
          } catch (error) {}
          navigate("/voucher");
          setIsErrorOTP(false);
        },
        (err) => {
          removeModalOpen();
          setIsErrorOTP(true);
        }
      )
    );
  };

  const updateUserInfo = () => {
    if (!!code) {
      dispatch(
        actions.EXCHANGE_CODE.request(
          {
            code: code,
            phoneNumber: phoneNumber,
            userName: fullName,
            dOB: birthDay || "",
            gender: genderSelected || null,
            otp: otp,
          },
          (res) => {
            setIsLoading(false);
            console.log("res===", res);
            if (!!res?.reward?.rewardId) {
              console.log("res===reward?", res?.reward);
              localStorage.setItem("rewardData", JSON.stringify(res?.reward));

              navigate("/game");
            } else {
              showDefaultErrModal();
            }
          },
          (err) => {
            setIsLoading(false);
            if (err?.status !== 500) {
              let errCode = err.data.error.errorCode;
              console.log("errCode=====>", err.data.error.errorCode);

              if (errCode == "InvalidOtp") {
                setIsErrorOTP(true);
              } else {
                checkError(errCode);
              }
            } else {
              showDefaultErrModal();
            }
          }
        )
      );
    }
  };

  const isValidPhone = (phone) => {
    var vnf_regex = /((09|03|07|08|05)+([0-9]{8})\b)/g;
    return vnf_regex.test(phone) ? true : false;
  };
  const validateCode = (data) => {
    if (isValidPhone(data.phone)) {
      setIsLoading(true);
      let params = {
        code: data.code,
        phoneNumber: data.phone,
      };
      dispatch(
        actions.VALIDATE_CODE.request(
          params,
          (res) => {
            requestOTP(data);
          },
          (err) => {
            removeModalOpen();
            removeDisableBtn("#btn-register");

            if (err?.status !== 500) {
              let errCode = err?.data?.error?.code;
              checkError(errCode);
            } else {
              showDefaultErrModal();
            }
          }
        )
      );
    } else {
      showModal();
      setNameBtn(`ĐÓNG`);
      setContent(
        `Số điện thoại bạn nhập không hợp lệ.<br/>Vui lòng kiểm tra lại.`
      );
    }
  };
  const checkError = (errCode) => {
    let content = "";
    switch (errCode) {
      case "InvalidCode":
        showModal();
        setNameBtn(`ĐÓNG`);
        content = `Mã số <b>${code}</b> không hợp lệ hoặc đã được sử dụng. Quý khách vui lòng thử lại.`;
        break;
      case "FinishedError":
        content = `Thời hạn chương trình khuyến mại đã kết thúc vào lúc 23:59 ngày 31/10/2023. Cảm ơn Quý khách đã tin dùng sản phẩm của Duy Tân.`;
        setNameBtn(`ĐÓNG`);
        setIsDisableInput(true);
        break;
      case "No_Available_Rewards_Error":
        showModal();
        setNameBtn(`ĐÓNG`);
        content = `Chương trình đã kết thúc do số lượng quà đã hết. Cảm ơn bạn đã tin dùng sản phẩm của Duy Tân.`;
        break;

      case "BlockedUser":
        showModal();
        setNameBtn(`ĐÓNG`);
        content = `Rất tiếc, Quý khách đã bị chặn vì nhập sai mã số quá 5 lần. Qúy khách vui lòng quay trở lại sau`;
        break;
      case "DuplicateAttemp":
        showModal();
        setNameBtn(`ĐÓNG`);
        content = `Mã số <b>${code}</b> không hợp lệ hoặc đã được sử dụng. Quý khách vui lòng thử lại.`;
        break;

      case "NotStartYetError":
        content = `Chương trình chưa bắt đầu. Vui lòng quay trở lại sau ngày <span>${START_DATE}</span>.
        `;
        actionTypeRef.current = "GO_TO_GUIDE";
        // startTimer();
        break;

      case "CampaignIsOver":
        content = `Chương trình đã kết thúc vào ngày <strong>${END_DATE}</strong>. Hẹn gặp lại bạn trong các chương trình sau.`;
        // startTimer();
        break;
      case "OUT_OF_STOCK":
        content = `Chương trình đã kết thúc trước thời hạn do hết quà. Cảm ơn bạn đã quan tâm đến chương trình và tin dùng sản phẩm từ P/S.`;
        setNameBtn(`ĐÓNG`);
        actionTypeRef.current = "GO_TO_GUIDE";
        localStorage.removeItem("sjkhjk");
        localStorage.removeItem("cghjfkhgj");
        localStorage.removeItem("tjfsaj");
        localStorage.removeItem("wish");
        break;

      case "CAMPAIGN_NOT_START_YET":
        content = `Chương trình chưa bắt đầu. <br />
          Vui lòng quay trở lại vào ngày ${AppConfigs.startDate}`;
        setNameBtn(`ĐÓNG`);
        actionTypeRef.current = "GO_TO_GUIDE";
        break;

      case "CAMPAIGN_ENDED":
        content = `Chương trình đã kết thúc vào ngày ${AppConfigs.endDate}.<br /> Hẹn gặp lại bạn trong các chương trình sau nhé.`;
        // setNameBtn(`ĐÓNG`);
        // actionTypeRef.current = "GO_TO_GUIDE";
        break;

      case "EXCEEDED_GIFT_PER_USER":
        content = `Số điện thoại này đã nhận voucher trước đó. Vui lòng tham gia chương trình sau nhé.`;
        setNameBtn(`ĐÓNG`);
        break;

      case "DUPLICATE_REQUEST":
        content =
          "Yêu cầu gửi mã OTP của bạn đang được chúng tôi xử lý, bạn hãy thử lại sau 1 phút nhé";
        setNameBtn(`ĐÓNG`);
        break;

      default:
        content = `Đã có lỗi xảy ra.<br/>
        Quý khách vui lòng thử lại sau.`;
        setNameBtn(`ĐÓNG`);
        break;
    }
    showModal();
    setContent(`${content}`);
  };
  const closeModalWhishNote = () => {
    setIsShowModalWhishNote(false);
    hideModal();
  };
  const showDefaultErrModal = () => {
    showModal();
    setNameBtn(`ĐÓNG`);
    setContent(`Đã có lỗi xảy ra!<br/>
    Vui lòng kiểm tra lại`);
  };

  const requestOTP = (data) => {
    setIsLoading(true);
    console.log("data", data);
    setOtpRequestTime(moment().utc().format());
    localStorage.setItem("accessToken", "");
    setIsErrorOTP(false);
    setOtp("");
    dispatch(
      actions.REQUEST_OTP.request(
        data,
        (res) => {
          timestampRef.current = res?.timestamp;
          setModalOtp(true);
          setOtpResponseTime(moment().utc().format());
          // OTPLog(res, data);
          setCode(data.code);
          setBirthDay(data.birthday);
          setPhoneNumber(data.phone);
          setFullName(data.fullName);
          setAddress(data.address);
          setModalOtp(true);
          console.log("success");
          removeModalOpen();
          setIsLoading(false);
        },
        (err) => {
          timestampRef.current = "";
          removeModalOpen();
          setIsLoading(false);
          removeDisableBtn("#btn-register");
          checkError(err?.data?.error?.code);
          setValue("isAgree", "");
        }
      )
    );
  };

  const playSong = (status) => {
    if (songLinkRef.current) {
      setStatusSong(status);
      if (status === "play") {
        audioRef.current = new Audio(songLinkRef.current);
        audioRef.current.currentTime = audioCurrentTimeRef.current;
        audioRef.current.play();
        audioRef.current.addEventListener("ended", function () {
          audioRef.current.currentTime = 0;
          console.log("ended");
          setStatusSong("paused");
        });
        setIsShowModalReceiveGifts(false);
      } else {
        try {
          audioCurrentTimeRef.current = audioRef.current.currentTime;
          audioRef.current.pause();
        } catch (error) {}
      }
    }
  };

  const clickAction = (e) => {
    switch (actionTypeRef.current) {
      case "GO_TO_INFORMATION":
        navigate("/information");
        break;

      case "GO_TO_GUIDE":
        navigate("/guide");
        break;

      case "FETCH_GIFTS":
        getGifts();
        break;

      default:
        hideModal();
        localStorage.setItem("accessToken", "");
        localStorage.setItem("userData", JSON.stringify({}));
        break;
    }
  };
  // useEffect(() => {
  //   if (imageUrl) {
  //     setIsShowModalWhishNote(true);
  //   } else {
  //   }
  // }, [imageUrl]);
  return (
    <div
      onClick={() => {
        if (modalOtp) {
          hideModal();
        }
      }}
    >
      <LoadingSpinner isLoading={isLoading} />
      <InformationPageView
        register={register}
        setValue={setValue}
        getValues={getValues}
        handleSubmit={handleSubmit(onSubmit)}
        rewardData={rewardData}
        isErrorPhoneNumber={isErrorPhoneNumber}
        valueDate={valueDate}
        isDisableInput={isDisableInput}
        wishContent={wishContent}
        songLinkRef={songLinkRef}
        songName={songName}
        playSong={playSong}
        statusSong={statusSong}
        showModalWhish={showModalWhish}
        setImageUrl={setImageUrl}
        frameName={frameName}
      />

      {isShowModalReceiveGifts && (
        <PopupReceiveGifts
          clickAction={() => {
            requestButtonTracking("button_Open_gifts_immediately", "Moquangay");
            playSong("play");
          }}
        />
      )}

      {modalOtp && (
        <PopupOtp
          setModal={setModalOtp}
          setOtp={setOtp}
          otp={otp}
          handleSubmitOTP={handleSubmitOTP}
          closeModalOTP={closeModalOTP}
          resendOTP={resendOTP}
          isErrorOTP={isErrorOTP}
        />
      )}
      {isShowModalWhishNote && (
        <PopupWhishNote
          dataModalTopup={dataModalTopup}
          closeModal={closeModalWhishNote}
          hasInfor={true}
          imageUrl={imageUrl}
        />
      )}

      {isShowModalSuccessNote && (
        <PopupSuccessNote
          clickAction={hideSuccessNote}
          clickAction1={clickGoSuccessWish}
        />
      )}
      {isShowModalSuccessWish && (
        <PopupWhishSuccess clickAction={hideSuccessWish} />
      )}

      {modal && (
        <PopupMessage
          nameBtn={nameBtn}
          nameBtn1={nameBtn1}
          nameBtn2={nameBtn2}
          setModal={setModal}
          content={content}
          groupBtnBlock={groupBtnBlock}
          clickAction={clickAction}
          clickAction1={clickAction}
          clickAction2={clickAction}
          clickAction3={clickAction}
          clickAction4={clickAction}
        />
      )}
    </div>
  );
};

export default InformationPage;
